import React from 'react';

import Background from '../../components/UI/Background/Background';

import DemoLogin from '../components/Auth/DemoLogin';

const DemoLoginPage = () => {
  return <>
    <Background />
    <DemoLogin />;
  </>
};

export default DemoLoginPage;
